import {routeConfig} from '$utils';
import {priviledges} from '$consts';

export default [
  routeConfig('FastSnaps', {
    topRow: false,
    ...priviledges.J,
  }, () => import('../views/FastSnaps.vue')),
];
